import React, { Component } from 'react';
import b from 'b_';
import { Link } from 'react-router-dom';

import { NewsItem } from '@interfaces/news-page';
import { formatDate } from 'client/helpers/date';

import './news.css';

interface NewsProps {
    items: NewsItem[];
    compact?: boolean;
    type?: string | false;
}

const class_ = b.with('news');

class News extends Component<NewsProps> {
    public render() {
        const { items, type = false } = this.props;

        return (
            <div className={class_({ type })}>
                {items.map(this.renderNews)}
            </div>
        );
    }

    private renderNews = (item: NewsItem) => {
        const { compact = false } = this.props;
        const url = `/news/${item.slug}`;
        const imageUrl = item.previewImage || item.image || '/no-record.png';
        const mods = { pinned: item.isPinned, compact };

        if (compact) {
            return (
                <div key={item.slug} className={class_('item', mods)}>
                    <div className={class_('item-meta')} key="meta">
                        {formatDate(item.createdAt)}
                    </div>
                    <Link className={class_('item-title')} key="link" to={url}>
                        {item.title}
                    </Link>
                </div>
            );
        }

        return (
            <div key={item.slug} className={class_('item', mods)}>
                <Link
                    className={class_('item-image')}
                    to={url}
                    style={{ backgroundImage: `url(${imageUrl})` }}
                />
                <div className={class_('item-content')}>
                    <Link className={class_('item-title')} key="link" to={url}>
                        {item.title}
                    </Link>
                    <div className={class_('item-description')}>{item.description}</div>
                    <div className={class_('item-meta')} key="meta">{formatDate(item.createdAt)}</div>
                </div>
            </div>
        );
    };
}

export default News;
